import { render, staticRenderFns } from "./ImageButton.vue?vue&type=template&id=7b61ed4a&"
import script from "./ImageButton.vue?vue&type=script&lang=js&"
export * from "./ImageButton.vue?vue&type=script&lang=js&"
import style0 from "./ImageButton.vue?vue&type=style&index=0&id=7b61ed4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports